import { fromJS } from "immutable";
import { MrReduxCrud } from "mr_react_framework";
import { axiosInstance } from "/src/api/apiModule";

const reduxCrud = new MrReduxCrud({
  axiosInstance,
  resourceName: "canvas_annotation",
  actionNames: ["FETCH", "CREATE", "UPDATE", "DELETE"],
});

const initialState = fromJS({
  canvas_annotations: [],
  page: 1,
  total_pages: 1,
  total_count: 0,
  page_size: 0,
  // action: {},
  error: null,
  loading: false,
});

export const actions = reduxCrud.getActions();
export const actionTypes = reduxCrud.getActionTypes();
export const reducer = reduxCrud.getReducer(initialState);
export const watchCanvasAnnotations = reduxCrud.generateWatchSaga({});

export default reduxCrud;
